import config from '../config';
import { setSpriteOnCanvas } from '../common';

const deviceCanvas = document.getElementById(
  "device-canvas"
) as HTMLCanvasElement;
const deviceContext = deviceCanvas.getContext("2d");

const scene1 = config["scene-1-7"];
const scene3 = config["scene-3"];

export default function(scene: typeof scene1 | typeof scene3){
  const specs = gsap.utils.toArray(`#${scene.id} .spec`);

  specs.forEach((spec: Element, index) => {
    const tlKeyframe = gsap.timeline({
      scrollTrigger: {
        id: `${scene.id}-${index + 1}-keyframe`,
        trigger: spec,
        start: function () {
          if (config.mobileLayout) {
            return `top bottom-=${config.pinLocationMobile}`;
          } else {
            // Precede the top landing at the pin target by the same amount the text scrollTrigger takes to start up fade-out
            return `top-=${config.scrollSpan} center+=${config.pinTextOffset}`;
          }
        },
        end: function () {
          if (config.mobileLayout) {
            return `+=${config.scrollSpanMobile * .5}`;
          }
          return `+=${config.scrollSpan}`;
        },
        pin: false,
        // markers: true,
        onUpdate: (self) => {
          let deviceAnimationIndex = index;
          if (scene.preceedingKeyframe === true) {
            // Spec index 1 (the 2nd spec) is the first one where we start the device animation
            if (index === 0) {
              return;
            }
            deviceAnimationIndex = index - 1;
          }

          const offset = deviceAnimationIndex * scene.keyframeSpan - 1;

          let targetFrame = Math.floor(
            self.progress * scene.keyframeSpan + offset
          );
          setSpriteOnCanvas({
            context: deviceContext,
            targetFrameIndex: targetFrame,
            spriteSettings: scene.sprites,
          });
        },
      },
    });

    const tlText = gsap.timeline({
      scrollTrigger: {
        id: `${scene.id}-${index + 1}-text`,
        trigger: spec,
        start: function () {
          if (config.mobileLayout) {
            return `top bottom-=${config.pinLocationMobile}`;
          }
          return `top center+=${config.pinTextOffset}`;
        },
        end: function () {
          if (config.mobileLayout) {
            return `+=${config.scrollSpanMobile}`;
          }
          return `+=${config.scrollSpan * 2}`;
        },
        pin: true,
        pinSpacing: false,
        anticipatePin: 1,
        // markers: true,
      },
    });
    tlText.addLabel("start");
    tlText.from(spec, {
      duration: 1,
      y: function () {
        if (config.mobileLayout) {
          return config.pinLocationMobile;
        }
        return config.scrollSpan;
      },
      autoAlpha: 0,
      ease: Sine.easeInOut,
    }, 'start');
    if (config.mobileLayout){
      tlText.addLabel("pause", `+=0`);
    } else {
      tlText.addLabel("pause", `+=.5`);
    }
    tlText.to(
      spec,
      {
        duration: .5,
        y: function () {
          if (config.mobileLayout) {
            return -config.pinLocationMobile / 2;
          }
          return -config.scrollSpan / 2;
        },
        autoAlpha: 0,
        ease: Sine.easeInOut,
      },
      "pause"
    );
  });
}
